import React from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  UnauthorisedPageSurface,
  PageWrapper,
} from "../../../../components/layout/container/Container";
import { FormSection } from "../../../../components/layout/forms/Index";
import TextField from "../../../../components/input/textfield/TextField";

import { useResetPassword } from "../hooks/useResetPassword";
import StatusAlert from "../../../../components/alerts/StatusAlert";

import Button from "../../../../components/buttons/Button";
import { PageHeader } from "../../../../components/layout/header/Header";
import { PageHeading } from "../../../../components/common/heading/Heading";
import FeedbackStatus from "../../../../components/feedback/FeedbackStatus";

import "./ResetPasswordPage.css";

const ResetPasswordPage = () => {
  document.title = "Katch | Reset Password";

  const { token } = useParams();
  const navigate = useNavigate();
  const { userData, passwords, setPasswords, status, handleUpdatePassword } =
    useResetPassword(token, navigate);

  const resetPasswordForm = (
    <>
      <PageHeader>
        <PageHeading
          title={"New password"}
          subTitle={
            <span>
              Remember your password?{" "}
              <Link to="/sign-in" style={{ color: "var(--ko-primary-blue-3)" }}>
                Sign in
              </Link>
            </span>
          }
        />
      </PageHeader>

      <FormSection>
        {status.message && <StatusAlert status={status} />}

        <TextField
          type="password"
          label="New Password"
          value={passwords.new}
          onChange={(e) =>
            setPasswords((prev) => ({ ...prev, new: e.target.value }))
          }
          placeholder="Enter new password"
          required
        />

        <TextField
          type="password"
          label="Confirm Password"
          value={passwords.confirm}
          onChange={(e) =>
            setPasswords((prev) => ({ ...prev, confirm: e.target.value }))
          }
          placeholder="Repeat new password"
          showPasswordOption
          required
        />
      </FormSection>

      <Button
        value={status.loading ? "Saving password..." : "Save Password"}
        style={{ width: "100%" }}
        onClick={handleUpdatePassword}
        disabled={status.loading}
      />
    </>
  );

  const errorDialog = (
    <div className="reset-password-content">
      <FeedbackStatus
        title={"Link expired"}
        description={
          <span className="mbr-access-form__text">
            For security, reset links expire quickly. Please request a new link
            to continue.
          </span>
        }
        buttonText={"Back to Sign in"}
        onAction={() => navigate("/sign-in")}
      />
    </div>
  );

  return (
    <UnauthorisedPageSurface>
      <PageWrapper size={"sm"}>
        <div className="reset-password-content">
          {status.loading && userData.email ? (
            <p style={{ textAlign: "center", fontSize: "var(--14px)" }}>
              Verifying secure session...
            </p>
          ) : userData.success ? (
            resetPasswordForm
          ) : (
            errorDialog
          )}
        </div>
      </PageWrapper>
    </UnauthorisedPageSurface>
  );
};

export default ResetPasswordPage;
